/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {selectParticipants} from '../api'

export const useMutationSelectParticipants = createReactQueryMutationHook('selectParticipants', selectParticipants)
